import { PasswordStrength } from '@components/PasswordStrength'
import styled from '@emotion/styled'
import { Box } from '@mui/material'

const StyledPasswordStrength = styled(PasswordStrength)`
	overflow: hidden;
	transition: max-height 0.15s ease-out;
	max-height: ${(props: { collapsed: boolean }) =>
		props.collapsed ? '0' : '250px'};
`

const DescriptionText = styled(Box)`
	${({ theme }) => `
		font-size: 14px;
		color: ${theme.palette.fonts.secondary};
	`}
`
export { DescriptionText, StyledPasswordStrength }
